<template>
  <div class="tapl">
    <div class="g-box">
      <div class="tapl-cap">{{ menu.subTitle }}</div>
      <div class="tapl-list">
        <div v-for="(item, index) in list" :key="index" class="tapl-list-item">
          <div class="item-left">
            <div class="item-cap">{{ item.title }}</div>
            <div class="item-tit">{{ item.tips }}</div>
          </div>
          <div class="item-right">
            <div
              class="item-ico"
              :style="{ backgroundImage: 'url(' + item.image + ')' }"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      pageSize: 10000000
    };
  },
  components: {},
  mounted() {},
  methods: {
    init() {
      this.params = this.$route.params;
      this.getList();
    }
  }
};
</script>
<style lang="less">
.tapl {
  padding-top: 54px;
}
.tapl-cap {
  color: #282828;
  font-size: 24px;
  text-align: center;
  font-weight: bold;
}
.tapl-list {
  padding: 80px 0;
}
.tapl-list-item {
  display: flex;
  align-items: center;
  position: relative;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    width: 2px;
    height: 100%;
    margin-left: -1px;
    background-color: #979797;
  }
  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 18px;
    height: 18px;
    margin-top: -9px;
    margin-left: -9px;
    background-color: #fd8f5d;
    border-radius: 50%;
    z-index: 1;
  }
  .item-left,
  .item-right {
    display: flex;
    width: 50%;
    flex-shrink: 0;
    padding: 30px 38px;
    box-sizing: border-box;
  }
  .item-left {
    flex-direction: column;
    align-items: flex-end;
  }
  .item-cap {
    color: #2d83df;
    font-size: 36px;
  }
  .item-tit {
    color: #282828;
    font-size: 16px;
    max-width: 400px;
    line-height: 22px;
    margin-top: 3px;
  }
  .item-ico {
    width: 110px;
    height: 110px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border-radius: 50%;
  }
  &:nth-child(2n) {
    flex-direction: row-reverse;
    .item-right {
      justify-content: flex-end;
    }
    .item-left {
      align-items: flex-start;
    }
  }
}
</style>
